// THIS FILE IS GENERATED BY 'npm run set-env-variables'

export const environment = {
  production: true,

  // Configuration/Feature-switches:
  envName: '🔍 Test',
  useServiceWorker: true,
  useOffers: false,
  useQandAs: true,
  useQandASearch: true,
  useRegionPerLocale: false,

  searchApi: 'https://hia-chatbot.azurewebsites.net/ask',
  searchApiKey: 'W$cXF3oi$!w9NMHUj9NTv&t*9UkuP9SjP5i8NZ^y',

  // Configuration of content
  appName: 'FAQ / Vraagbaak',
  appLogoUrl: 'https://rodekruis.github.io/510-ICON-LIBRARY/Beeldmerk_van_het_Nederlandse_Rode_Kruis.svg',
  mainPageHeader: 'This web app is made to give helpful information (HIA) about frequently asked questions (FAQ).',
  mainPageIntroduction: 'Please select your FAQ below:',
  mainPageNotification: '',
  errorHeader: 'Data Unavailable',
  errorMessage: 'Reach out to us at: ',
  errorContactUrl: 'https://www.rodekruis.nl/',
  errorRetry: 'Try again?',

  // Regions:
  regions: 'ukraine, oekraine, shelter, opvang, , , undocumented-migrants, eu-migrants,',
  regionsLabels: 'Ukraine (EN), Oekraïne (NL), Asylum seeker (EN), Asielzoeker (NL), , , Undocumented Migrants, EU Migrants,',
  regionsSheetIds: '14NZwDa8DNmH1q2Rxt-ojP9MZhJ-2GlOIyN8RF19iF04, 1scCAXRoM66dFbR6f2Lj5FwLWZxm3SLbIgt58LeNNeHE, 15yXp_w0chnFRwIfvY6uRgs7TwzxwuBz9iz-dgDFHsbs, 1wJ4pfB3l7t16igivt_LkGYmaqZ0hiRsR7_giJUjen-s, , , 1Veli11xRUzIbmfTF8N57xAZqnMWcH1yKVP63PpfXF7s, 1SCyJ8v7blSDaeehWuImaRvwXMXC-9o7kbC5bnmotAYw,',

  // Third-party tokens:
  // Google Sheets API:
  google_sheets_api_key: 'AIzaSyCe9bIK2yLJTvRWGoYgaT5H7Lng1WBi6po',
  google_sheets_api_url: 'https://sheets.googleapis.com/v4/spreadsheets',

  // Application Insights
  appInsightsConnectionString: 'InstrumentationKey=d9a21705-a3bd-4ec6-bcaf-b1659f44f2cf;IngestionEndpoint=https://westeurope-5.in.applicationinsights.azure.com',
};
